import { render, staticRenderFns } from "./TutorialUI.vue?vue&type=template&id=b95e2040&scoped=true&"
import script from "./TutorialUI.vue?vue&type=script&lang=js&"
export * from "./TutorialUI.vue?vue&type=script&lang=js&"
import style0 from "./TutorialUI.vue?vue&type=style&index=0&id=b95e2040&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95e2040",
  null
  
)

export default component.exports